// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3E-Rw","errors":"Errors_errors__1_K6w"};